import {BaseEntity} from "../../entities/BaseEntity";
import {IService} from "../../services/IService";
import {NotificationService} from "../../services/NotificationService";

export class PagingModel<T extends BaseEntity> {
    pagingService: IService;
    page: number = 1;
    pageSize: number = 10;
    totalItems: number = 100000;
    items: T[] = [];
    search: string = "";
    orderColumn: string = "";
    orderDirection: string = "";
    selectedItems: T[] = [];
    $q: ng.IQService;
    nameValuePairs: [string, string, number][] = [];

    constructor($q: ng.IQService, pagingService: IService, public notificationService: NotificationService) {
        this.pagingService = pagingService;
        this.$q = $q;
    }

    getPagedPromise(): ng.IPromise<any> {
        return this.pagingService.getPaged(this.search, this.page, this.pageSize, this.orderColumn, this.orderDirection);
    }

    entityName(): string {
        return "";
    }

    getCountPromise(): ng.IPromise<any> {
        return this.pagingService.getCount(this.search);
    }

    transformItem(entity: T) {
    }

    getPaged(): ng.IPromise<any> {
        this.selectedItems = [];
        return this.$q.all([
            this.getPagedPromise(),
            this.getCountPromise()
        ])
            .then((data: any) => {
                for(var i=0; i < data[0].length; i++){
                    var item = data[0];
                    this.transformItem(item);
                }
                this.items = data[0];
                this.totalItems = data[1];
            })
            .catch((err: any) => {
                this.notificationService.notifyError(err);
            });
    }

    addSelected(item: any): void {
        var foundIndex = this.selectedItems.indexOf(item);
        if (foundIndex != -1)
            this.selectedItems[foundIndex] = item;
        else
            this.selectedItems.push(item);
        this.selectionChanged();
    }

    removeSelected(item: any): void {
        var foundIndex = this.selectedItems.indexOf(item);
        if (foundIndex != -1)
            this.selectedItems.splice(foundIndex, 1);
        this.selectionChanged();
    }

    selectionChanged(): void {
    }

    getColumnDefs(): ng.IPromise<void> {
        return null;
    }

}
